export const DEFAULT_LOCALE = 'ko'

export const DISCONNECT_WARNING_THRESHOLD_MS = 1000

export const LLM_MODELS = [
  { id: 'gemini-nano', name: 'Gemini nano' },
  { id: 'onnx-community/Qwen3-0.6B-ONNX', name: 'Qwen3-0.6B-ONNX' },
  {
    id: 'onnx-community/granite-4.0-350m-ONNX-web',
    name: 'Granite4Nano 350M (fp16)'
  },
  {
    id: 'onnx-community/granite-4.0-1b-ONNX-web',
    name: 'Granite4Nano 1B (q4)'
  },
  {
    id: 'onnx-community/granite-4.0-micro-ONNX-web',
    name: 'Granite4Nano 3B (q4f16)'
  }
  // { id: 'Llama-2-7b-chat-hf-q4f32_1', name: 'Llama-2' },
  // { id: 'WizardMath-7B-V1.1-q4f16_1', name: 'Mistral variants' },
  // { id: 'gemma-2b-it-q4f32_1', name: 'Gemma-2B' },
  // { id: 'RedPajama-INCITE-Chat-3B-v1-q4f32_1', name: 'RedPajama' },
  // { id: 'Phi2-q0f32', name: 'Phi-2' },
  // { id: 'Phi1.5-q0f32', name: 'Phi-1.5' },
  // { id: 'TinyLlama-1.1B-Chat-v0.4-q0f32', name: 'TinyLlama' }
]

export const VLM_MODELS = [
  { id: 'HuggingFaceTB/SmolVLM-500M-Instruct', name: 'SmolVLM-500M-Instruct' },
  { id: 'florence', name: 'Florence' },
  { id: 'onnx-community/FastVLM-0.5B-ONNX', name: 'FastVLM-0.5B-ONNX' },
  { id: 'mistralai/Ministral-3-3B-Instruct-2512-ONNX', name: 'Ministral' }
]

export const SCREEN_BREAKPOINTS = {
  SM: 360,
  MD: 1200
} as const
